import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import UIPanelFooter from 'UIComponents/panel/UIPanelFooter';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import { PickerTypes } from '../constants';
const ALLOW_CLOSE_AFTER_MS = 5000;

// sits underneath the iframe and provides loading spinner, slide in/out animation and box-shadow on left
const PanelSkeleton = ({
  iframeLoaded,
  loadingFailed,
  pickerType,
  panelWidth,
  onClose
}) => {
  const isMounted = useRef(false);
  const [allowClose, setAllowClose] = useState(false); // show a close button if the iframe does not load quickly, to prevent users from closing while waiting for the initial onLoad event

  useEffect(() => {
    isMounted.current = true;
    setTimeout(() => {
      if (isMounted.current && !iframeLoaded) {
        setAllowClose(true);
      }
    }, ALLOW_CLOSE_AFTER_MS);
    return () => {
      isMounted.current = false;
    };
  }, [iframeLoaded]);
  const HeaderComponent = pickerType === PickerTypes.SIDE_MODAL ? UIDialogHeader : UIPanelHeader;

  const panelContent = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HeaderComponent, {
      children: allowClose && /*#__PURE__*/_jsx(UIDialogCloseButton, {
        "data-test-id": "picker-skeleton-close",
        onClick: onClose
      })
    }), /*#__PURE__*/_jsxs(UIPanelBody, {
      children: [loadingFailed && /*#__PURE__*/_jsx(UIAlert, {
        type: "danger",
        className: "m-all-4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "fileManager.errors.loadingFailed"
        })
      }), !iframeLoaded && !loadingFailed && /*#__PURE__*/_jsx(UILoadingOverlay, {
        contextual: true,
        "data-test-id": "panel-loading-overlay"
      })]
    }), /*#__PURE__*/_jsx(UIPanelFooter, {
      children: /*#__PURE__*/_jsx("div", {
        style: {
          height: 39
        }
      })
    })]
  });

  const renderSideModal = () => {
    return /*#__PURE__*/_jsx(UIModalPanel, {
      className: "mce-ignore",
      width: panelWidth,
      style: {
        backgroundColor: loadingFailed ? 'white' : ''
      },
      onEsc: allowClose ? onClose : undefined,
      "data-test-id": "picker-panel-skeleton",
      children: panelContent
    });
  };

  const renderPanel = () => {
    return /*#__PURE__*/_jsx(UIPanel, {
      className: "mce-ignore",
      width: panelWidth,
      style: {
        backgroundColor: loadingFailed ? 'white' : ''
      },
      "data-test-id": "picker-panel-skeleton",
      children: panelContent
    });
  };

  return pickerType === PickerTypes.SIDE_MODAL ? renderSideModal() : renderPanel();
};

export default PanelSkeleton;